import request from '@/utils/request'
import {exp} from "mathjs";

export function getDetail(id) {
  return request({
    url: '/api/maintenance/' + id,
    method: 'get',
    params: {}
  })
}

export function getReports (data) {
  return request({
    url: '/api/maintenance',
    method: 'get',
    params: data
  })
}

export function saveReport(id, data) {
  return request({
    url: '/api/maintenance-man/' + id,
    method: 'put',
    data: data
  })
}

export function getImageOss() {
  return request({
    url: '/api/report-oss',
    method: 'get',
    params: {}
  })
}

export function submitReport(data) {
  return request({
    url: '/api/submit-report',
    method: 'POST',
    data: data
  })
}

export function reports(id) {
  return request({
    url: '/api/maintenance-report/' + id,
    method: 'GET',
    params: {}
  })
}

export function searchWorkers(data) {
  return request({
    url: '/api/an/worker/getAllWorkerList',
    method: 'get',
    params: data
  })
}

export function details(id, data = {}) {
  return request({
    url: '/api/man/order-timeline/' + id,
    method: 'get',
    params: data
  })
}

export function changeOssUrl(data) {
  return request({
    url: '/api/man-show-url',
    method: 'get',
    params: data
  })
}

export function categoryAll() {
  return request({
    url: '/api/man-category-all',
    method: 'get',
    params: {},
  })
}

export function cityList() {
  return request({
    url: '/api/man-city-list',
    method: 'get',
    params: {}
  })
}

export function brandList() {
  return request({
    url: '/api/man-brand-list',
    method: 'get',
    params: {}
  })
}

export function marketList(city) {
  return request({
    url: '/api/man-market-list',
    method: 'get',
    params: {city: city}
  })
}

export function shopList(data) {
  return request({
    url: '/api/man-shop-list-all',
    method: 'get',
    params: data
  })
}

export function createOrder(data) {
  return request({
    url: '/api/an/worker/createOrder',
    method: 'post',
    data: data
  })
}

export function calendar() {
  return request({
    url: '/api/man-appointment-show',
    method: 'get',
    params: {}
  })
}

export function maintenanceRecords(date) {
  return request({
    url: '/api/maintenance-record/' + date,
    method: 'get',
    params: {}
  })
}

export function qyts() {
  return request({
    url: '/api/qty-map',
    method: 'get',
    params: {}
  })
}

export function reimbursement(data) {
  return request({
    url: '/api/reimbursement',
    method: 'post',
    data: data
  })
}

export function companies() {
  return request({
    url: '/api/man-company-list-all',
    method: 'get',
    params: {}
  })
}

export function manCategoryLevel2(id) {
  return request({
    url: '/api/man-category-level2/' + id,
    method: 'get',
    params: {}
  })
}

export function workerWarrantyList(data) {
  return request({
    url: '/api/maintenance-general',
    method: 'get',
    params: data
  })
}

export function orderInfo(id, data) {
  return request({
    url: '/api/order-base/' + id,
    method: 'get',
    params: data
  })
}

export function getOrderList(data) {
  return request({
    url: '/api/an/worker/getOrderList',
    method: 'get',
    params: data
  })
}

/**
 * 创建维修报告
 * @param data
 * @returns {*}
 */
export function operateReport(data) {
  return request({
    url: '/api/an/worker/createOrUpdateCoReport',
    method: 'post',
    data: data
  })
}

export function getUnitList() {
  return request({
    url: '/api/an/worker/getUnitList',
    method: 'get'
  })
}

export function submitAppoTask(data) {
  return request({
    url: '/api/an/worker/submitAppoTask',
    method: 'post',
    data: data
  })
}

export function createReport(data) {
  return request({
    url: '/api/an/worker/createOrUpdateCoReport',
    method: 'post',
    data: data
  })
}

export function getOssToken (data) {
  return request({
    url: '/api/an/worker/getUploadToken',
    method: 'get',
    params: data
  })
}

export function getSubmitInfo(data) {
  return request({
    url: '/api/an/worker/getAppoTaskSubmitInfo',
    method: 'get',
    params: data
  })
}

export function getNodeList(data) {
  return request({
    url: '/api/an/worker/getNodeList',
    method: 'get',
    params: data
  })
}

export function getOrderStatusList() {
  return request({
    url: '/api/an/worker/getOrderStatusList',
    method: 'get'
  })
}

export function getCityList() {
  return request({
    url: '/api/an/worker/getCityList',
    method: 'get'
  })
}

export function getMarketList(data) {
  return request({
    url: '/api/an/worker/getMarketList',
    method: 'get',
    params: data
  })
}

export function getBrandList() {
  return request({
    url: '/api/an/worker/getBrandList',
    method: 'get'
  })
}

export function getShopList(data) {
  return request({
    url: '/api/an/worker/getShopList',
    method: 'get',
    params: data
  })
}

export function getWorkingCalendar() {
  return request({
    url: '/api/an/worker/getCoCalendar',
    method: 'get'
  })
}

/**
 * 通过日期查询数据
 * @param data
 * @returns {*}
 */
export function getWorkingByDate(data) {
  return request({
    url: '/api/an/worker/getCoByDate',
    method: 'get',
    params: data
  })
}

/**
 * 获取维修类目
 * @param data
 * @returns {*}
 */
export function getMaCateLv1List(data) {
  return request({
    url: '/api/an/worker/getMaCateLv1List',
    method: 'get',
    params: data
  })
}

export function getWorkerInfoReport(data) {
  return request({
    url: '/api/an/worker/getWorkerInfoReport',
    method: 'get',
    params: data
  })
}

export function workerCreateOrUpdateWorkerInfoReport(data) {
  return request({
    url: '/api/an/worker/workerCreateOrUpdateWorkerInfoReport',
    method: 'post',
    data: data
  })
}

/**
 * 获取报告工人列表
 * @param data
 * @returns {*}
 */
export function getReportWorkerList(data) {
  return request({
    url: '/api/an/worker/getReportWorkerList',
    method: 'get',
    params: data
  })
}

export function getCountPdf(data) {
  return request({
    url: '/api/workerReport',
    method: 'get',
    params: data
  })
}

/**
 * 获取标题
 * @returns {*}
 */
export function getTipList() {
  return request({
    url: '/api/an/worker/getTipList',
    method: 'get'
  })
}

/**
 * 添加店铺
 * @returns {*}
 */
export function addStore(data) {
  return request({
    url: '/api/an/worker/autoCreateStore',
    method: 'post',
    data
  })
}

export function getMaCateLv0List() {
  return request({
    url: '/api/an/worker/getMaCateLv0List',
    method: 'get'
  })
}

export function parseAddress(data) {
  return request({
    url: '/api/an/worker/address/parse',
    method: 'get',
    params: data
  })
}

export function postCard(data) {
  return request({
    url: '/api/an/worker/workerCallback',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js